import { useMutation, useQueryClient } from 'react-query'
import { QUERY_KEYS } from 'src/constants'
import { quantityTypesService } from 'src/services/quantity-types.service'
import { CreateQuantityTypeDto } from 'src/types'

const useCreateQuantityType = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (dto: CreateQuantityTypeDto) => quantityTypesService.createCategoryValue(dto),
    {
      onSuccess() {
        queryClient.invalidateQueries(QUERY_KEYS.QUANTITY_TYPES)
      },
    },
  )
}

export { useCreateQuantityType }
